export const busLogs = {
  tabs: {
    queryBus: 'Query bus',
    commandBus: 'Command bus',
  },
  filters: {
    key: 'Key',
    user: 'User',
    onlyFailed: 'Only failed',
    dateFrom: 'Date from',
    dateTo: 'Date to',
  },
  detail: {
    payload: 'Payload',
    errorMessage: 'Error message',
  },
  refresh: 'Refresh',
  noPermission: 'Missing permission: {permission}',
}
